<mat-checkbox
  (change)="onInput($event)"
  (blur)="onBlur()"
  *ngFor="let item of optionsList"
  [value]="item.value"
  [checked]="isChecked(item.value)"
  [disabled]="disabled"
>
  {{ item.title }}
</mat-checkbox>